import React, { ReactNode } from "react";
import { standardHorizontalPadding } from "../utils/static-values.ts";
import { cn } from "../utils/cn.ts";

interface PageComponentContainer {
  children: ReactNode;
  additionalStyles?: string;
  additionalOuterStyles?: string;
  fullWidthWithGrayBackground?: boolean;
}

const commonStyles = "py-[30px] md:py-[50px] lg:py-[60px] w-full max-w-espc-max-content";
export const PageComponentContainer: React.FC<PageComponentContainer> = ({
  children,
  additionalStyles,
  additionalOuterStyles,
}) => {
  return (
    <div className={`${standardHorizontalPadding} ${additionalOuterStyles ?? ""}`}>
      <div className={cn(`${commonStyles} mx-auto ${additionalStyles ?? ""}`)}>{children}</div>
    </div>
  );
};
